import { Address, DashboardAdditionalInfo } from 'api/ApplicationApi';
import { BorrowerRole } from 'enums/BorrowerRole';
import { EMPLOYMENT_SECTION_AMOUNT } from 'pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.constants';
import { CurrentEmploymentVariable } from 'pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.enums';

export const getEmploymentVariableName = (
  variableKey: string,
  borrowerType: BorrowerRole = BorrowerRole.Borrower,
  index: number = 1,
) => {
  const postfix = index === 1 ? '' : `_${index}`;

  return `${borrowerType === BorrowerRole.Borrower ? '' : 'co'}${variableKey}${postfix}`;
};

export const getEmploymentsAmount = (borrowerType: BorrowerRole, variables: any): number => {
  let result = 0;

  for (let index = 1; index <= EMPLOYMENT_SECTION_AMOUNT; index++) {
    if (!variables[getEmploymentVariableName(CurrentEmploymentVariable.EmployerName, borrowerType, index)]) {
      return index - 1;
    }

    result = index;
  }

  return result;
};

export const getIsAddressInformationDisabled = (address: Address): boolean => {
  return Object.values(address).every((value) => !!value);
};

export const getIsInitialValueNotNull = (initialValue: any): boolean => {
  return !!initialValue;
};

export const getIsEmploymentSectionCompleted = (
  dashboardAdditionalInfo: DashboardAdditionalInfo,
  borrowerType: BorrowerRole,
): boolean => {
  const {
    isBorrowerCurrentEmploymentsRequired,
    isPartialBorrowerCurrentEmploymentsRequired,
    isBorrowerCurrentEmploymentsCompleted,
    isBorrowerPreviousEmploymentRequired,
    isBorrowerPreviousEmploymentCompleted,
    isBorrowerEmploymentStatusInformationRequired,
    isBorrowerEmploymentStatusInformationCompleted,
    isCoBorrowerCurrentEmploymentsRequired,
    isPartialCoBorrowerCurrentEmploymentsRequired,
    isCoBorrowerCurrentEmploymentsCompleted,
    isCoBorrowerPreviousEmploymentRequired,
    isCoBorrowerPreviousEmploymentCompleted,
    isCoBorrowerEmploymentStatusInformationRequired,
    isCoBorrowerEmploymentStatusInformationCompleted,
  } = dashboardAdditionalInfo;

  const isBorrower = borrowerType === BorrowerRole.Borrower;
  const isCurrentEmploymentsRequired = isBorrower
    ? isBorrowerCurrentEmploymentsRequired || isPartialBorrowerCurrentEmploymentsRequired
    : isCoBorrowerCurrentEmploymentsRequired || isPartialCoBorrowerCurrentEmploymentsRequired;

  const isCurrentEmploymentsCompleted = isBorrower
    ? isBorrowerCurrentEmploymentsCompleted
    : isCoBorrowerCurrentEmploymentsCompleted;

  const isPreviousEmploymentRequired = isBorrower
    ? isBorrowerPreviousEmploymentRequired
    : isCoBorrowerPreviousEmploymentRequired;

  const isPreviousEmploymentCompleted = isBorrower
    ? isBorrowerPreviousEmploymentCompleted
    : isCoBorrowerPreviousEmploymentCompleted;

  const isEmploymentStatusInformationRequired = isBorrower
    ? isBorrowerEmploymentStatusInformationRequired
    : isCoBorrowerEmploymentStatusInformationRequired;

  const isEmploymentStatusInformationCompleted = isBorrower
    ? isBorrowerEmploymentStatusInformationCompleted
    : isCoBorrowerEmploymentStatusInformationCompleted;

  return (
    (isCurrentEmploymentsRequired ? isCurrentEmploymentsCompleted : true) &&
    (isPreviousEmploymentRequired ? isPreviousEmploymentCompleted : true) &&
    (isEmploymentStatusInformationRequired ? isEmploymentStatusInformationCompleted : true)
  );
};
